import { styled } from 'goober';
import { forwardRef } from 'react';

export const TabsContainer = styled('div')`
    height: 32px;
    background-color: ${(props) => props.theme.colors.ui.white};
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.w300};
`;

export const TabButton = styled('button', forwardRef)<{ selected: boolean; $disabled?: boolean }>`
    height: 32px;
    padding: 0px 12px;
    display: inline-block;
    outline: none;
    background-color: transparent;
    border: none;
    cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
    font-size: 12px;
    color: ${(props) =>
        props.selected
            ? props.theme.colors.primary.w500
            : props.$disabled
            ? props.theme.colors.neutral.w600
            : props.theme.colors.ui.dark};
    border-bottom: 1px solid ${(props) => (props.selected ? props.theme.colors.primary.w500 : 'transparent')};
    transit &:hover {
        border-bottom-color: ${(props) =>
            props.selected ? props.theme.colors.primary.w500 : props.theme.colors.neutral.w500};
    }
`;
